'use client';

import type { RefObject } from 'react';
import { startTransition, useEffect, useRef, useState } from 'react';

export function useIsScrolling(ref: RefObject<HTMLElement | null>) {
  const [scrolling, setScrolling] = useState(false);

  const state = useRef({
    scrollEndTime: 0,
    scrollTimeout: null,
  });

  useEffect(() => {
    const onWheel = () => {
      startTransition(() => {
        setScrolling(true);
      });
      const now = Date.now();
      if (state.current.scrollEndTime < now + 50) {
        state.current.scrollEndTime = now + 300;
        // @ts-expect-error FIXME(strictNullChecks)
        clearTimeout(state.current.scrollTimeout);
        // @ts-expect-error FIXME(strictNullChecks)
        state.current.scrollTimeout = setTimeout(() => {
          startTransition(() => {
            setScrolling(false);
          });
          state.current.scrollTimeout = null;
        }, 300);
      }
    };

    const el = ref.current;

    // @ts-expect-error FIXME(strictNullChecks)
    el.addEventListener('wheel', onWheel, {
      passive: true,
    });

    return () => {
      // @ts-expect-error FIXME(strictNullChecks)
      el.removeEventListener('wheel', onWheel);
    };
  }, [ref]);

  return scrolling;
}
